import type { APIShelfFile, APIResource, ViewAccessType, UpdatedBy } from '~~/entities/api'
import type { DeepReadonly } from 'vue'
import type { Slide } from '~~/entities/slide'
import type { Asset } from '~~/entities/asset'
import type { Company } from './company'

export enum DeckMode {
  EditMode = 'edit',
  PresentationMode = 'presentation',
  ParticipantMode = 'participant',
  EmbedMode = 'embed',
  LoadingMode = 'loading',
}

export type DeckPermissions = {
  create: boolean
  destroy: boolean
  read: boolean
  update: boolean
  write: boolean
}

export interface Deck extends APIResource {
  id: string | number
  deck_image?: string
  is_paid?: string
  company_id?: number
  title: string
  description?: string
  press_release_headline?: string
  deck_order?: number
  url_slug?: string
  view_access_type?: ViewAccessType
  edit_access_type?: 'private' | 'selected'
  base_access?: DeckBaseAccess
  created_at: string
  updated_at: string
  deleted_at?: string
  file?: APIShelfFile
  file_id?: number
  archived?: boolean
  thumbnail?: string
  press_release_date?: string
  latest_content?: string
  allow_internal_access?: boolean
  is_featured?: boolean
  show_3d_menu?: boolean
  type_tags?: ('Investor' | 'Technical' | 'Virtual Site Visit' | 'Press Release' | 'ESG')[]
  tags?: ('360' | '3D' | 'Cash Flow Model')[]
  offline_content_last_updated?: string
  status?: 'ready' | 'cloning'
  slides?: Slide[]
  company: DeepReadonly<Company>
  assets?: Asset[]
  permissions?: DeckPermissions
  has_secure_links?: boolean
  embed_type?: 'embed_classic' | 'embed' | 'embed_partner'
  embed_name?: string
  partner_id?: string
  partner_name?: string
  updated_by?: UpdatedBy | null
  created_by?: UpdatedBy | null
}

export enum DeckUserType {
  Host = 'host',
  Controlled = 'controlled',
  Viewer = 'viewer',
}

export enum DeckBaseAccess {
  Public = 'public',
  Private = 'private',
  CompanyEdit = 'company_edit',
  CompanyView = 'company_view',
}

export enum DeckPermissionsUserRole {
  Viewer = 'viewer',
  Editor = 'editor',
  Owner = 'owner',
}
